import { SLOTS_APIS } from "@/api_framework/api_config";

import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import { IOverBookingUserListResponse } from "@/api_framework/api_modals/Bookings";
import { setUserListData } from "@/app_redux/reducers/slices/auth/slots_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

export interface IBdeUserListParams {
  clinic_ids?: string[];
  selected_date?: string;
  service_id?: string[];
  subservice_id?: string[];
}

AxiosCurlirize(axios, () => {});
export const useOverBookingBdeUserListAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async (params?: IBdeUserListParams) => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const payload = {
        ...(params?.service_id?.length && { service_id: params.service_id }),
        ...(params?.subservice_id?.length && { subservice_id: params.subservice_id }),
      };
      await axios
        .post(SLOTS_APIS?.BDE_USER_LIST?.baseURL ?? "", payload, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
          params: {
            ...(params?.clinic_ids?.length && { clinic_ids: params.clinic_ids.join(",") }),
            ...(params?.selected_date && { selected_date: params.selected_date }),
          },
        })
        .then((res: AxiosResponse<IOverBookingUserListResponse>) => {
          if (res.data.status === true) {
            //
            dispatch(
              setUserListData({
                data: res.data.data,
              }),
            );
          } else {
            dispatch(
              setUserListData({
                data: [],
              }),
            );
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          if (e.status === 400 || e.code === "ERR_BAD_REQUEST") {
            toast.error("Error while fetching booking BDE List");
          }
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
